
const HomePage = () => {
  const projects = [
    { id: 1, name: "Ameerjet", icon: "ameerjet", color: "#4F46E5", link: "https://ameerjet.ameergroups.com/" },
    { id: 2, name: "أمير لمستلزمات الطباعة", icon: "amir-printing", color: "#4F46E5", link: "https://uvhouse.ameergroups.com?link=ameer_printing" },
    { id: 3, name: "أمير لقطع غيارات الطابعات", icon: "printer-parts", color: "#10B981", link: "https://uvhouse.ameergroups.com?link=printer_parts" },
    { id: 4, name: "أمير للدعاية والطباعة", icon: "amir-advertising", color: "#F59E0B", link: "https://uvhouse.ameergroups.com?link=ameer_advertising" },
    { id: 5, name: "فن الأكريلك", icon: "acrylic-art", color: "#EF4444", link: "https://uvhouse.ameergroups.com?link=acrylic_art" },
    { id: 6, name: "Sublimation For Everything", icon: "sublimation", color: "#8B5CF6", link: "https://uvhouse.ameergroups.com?link=sublimation" },
    { id: 7, name: "Super DTF", icon: "super", color: "#06B6D4", link: "https://uvhouse.ameergroups.com?link=dtf" },
    { id: 8, name: "UV House", icon: "uv-house", color: "#EC4899", link: "https://uvhouse.ameergroups.com?link=uv" },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-800 font-sans selection:bg-indigo-100">
      <nav className="max-w-5xl mx-auto px-6 py-8 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-xl font-bold tracking-tight text-slate-900">
            <img src="/images/logo.png" alt="" className="h-16" />
          </span>
        </div>
        <div className="flex bg-white shadow-sm border border-slate-200 rounded-full px-6 py-2 gap-6 text-sm font-medium">
          <a href="#" className="hover:text-indigo-600 transition">اتصل بنا</a>
          <a href="#" className="hover:text-indigo-600 transition">من نحن</a>
          <a href="#" className="hover:text-indigo-600 transition">الرئيسية</a>
        </div>
      </nav>
      <main className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {projects.map((project) => (
            <a
              key={project.id}
              href={project.link}
              className="group relative flex flex-col items-center justify-center p-4 bg-white border border-slate-200 rounded-3xl transition-all duration-300 hover:border-indigo-300 hover:shadow-[0_20px_40px_-15px_rgba(79,70,229,0.15)] active:scale-95"
            >
              <div
                className="size-16 md:size-20 mb-4 rounded-2xl flex items-center justify-center text-3xl md:text-4xl transition-transform duration-500 group-hover:rotate-[10deg]"
                style={{ backgroundColor: `${project.color}15`, color: project.color }}
              >
                <img src={`/images/${project.icon}.jpg`} alt="" />
              </div>
              <h3 className="font-bold text-slate-900 text-center text-sm md:text-base mb-1">
                {project.name}
              </h3>
              <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
                انتقال الآن
              </span>

              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="size-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </div>
            </a>
          ))}
        </div>
      </main>
      <footer className="max-w-5xl mx-auto px-6 py-6 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-400 text-sm">
        <p>© 2026 Ameer Group. جميع الحقوق محفوظة.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-indigo-600 transition">Privacy</a>
          <a href="#" className="hover:text-indigo-600 transition">Terms</a>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;